import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import {OAuth} from "@prowin/oauth2-client";
import {Salespartner, SalespartnerInterface} from "@prowin/salespartner-client";

import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import AlertTitle from '@mui/material/AlertTitle';
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import {loadSalespartner} from "./lib/salespartner";
import {languageDefault, loadTranslations} from "./languages/language";
import {bffInitOAuth} from "./lib/oauth2";

import renderEmployeePortal from "./components/Employee/employeePortal";

import {LocalizationMessages} from "piral";
import {BFFOAuthClient} from "@prowin/bff-oauth-client";
import {Translations} from "piral-translate";
import {Logger} from "@prowin/logger";

const PROWIN_LOGO = require('./assets/img/icon-144x144.png');

// registerServiceWorker();

type PortalModule = {
    renderPortal: (translations: Translations, oauthClient: OAuth, salespartner: Salespartner) => void;
};

bffInitOAuth().then( bffOauthClient => {

    if(window.location.pathname.includes('switch-login') || window.location.pathname.includes('switchlogin')){
        bffOauthClient.login(true);
        return;
    }

    if(bffOauthClient.user.userType === "employee"){
        Promise.all([loadTranslations([languageDefault]),])
            .then(([translations]) => {
                renderEmployeePortal(translations, bffOauthClient)
            });
    }

    if(bffOauthClient.user.userType === "sales_partner") {
        handleLoadingSalespartner(bffOauthClient)
    }
}).catch(error => {
    errorRenderer(error)
})


const handleLoadingSalespartner = (oauthClient: BFFOAuthClient) => {
    loadSalespartner(oauthClient)
        .then((salespartnerData: SalespartnerInterface) => {
            const translationsPromise: Promise<LocalizationMessages> = loadTranslations(salespartnerData ? salespartnerData.clientData.languages : [languageDefault]);

            Promise.all<[LocalizationMessages, PortalModule]>([translationsPromise,import("./portal")] as any)
                .then(([translations, { renderPortal}]) => {
                    if ((oauthClient.initialized && salespartnerData.id)) {
                        renderPortal(translations, oauthClient, salespartnerData);
                    }
                });

        }).catch( error => {
        Logger.log("Error occurred fetching salespartner?")

        errorRenderer(error)
    });
}

const errorRenderer = (error: Error) => {
    ReactDOM.createRoot(document.getElementById('app'))
        .render(
            <Stack gap={2} padding={2}>
                <Box component="img" src={PROWIN_LOGO} alt="proWIN"
                     sx={{
                         width: "50px",
                         height: "50px",
                         alignSelf: "center"
                     }}/>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    <Typography>{error?.message ?? error.toString()}</Typography>
                </Alert>
            </Stack>

        )
}